  /* eslint-disable */
 import { createRouter, createWebHistory } from 'vue-router'
import CommonQuestions from '../components/CommonQuestions/CommonQuestion'
import HomePage from '../components/Layout/HomePageComponent'
import SignIn from '../components/Registration/SignInComponent'
import SignUp from '../components/Registration/SignUpComponent'
import Programs from '../components/Programs/ProgramComponent'
import ProgramsTypePage from '../components/Programs/ProgramTypeComponent'
import InterestedPartners from '../components/InterestedPartners/InterestedPartner'

const routes = [
   // { path: process.env.BASE_URL, name: 'Home', component: HomePage, meta: { reuse: false } },
   //{ path: process.env.BASE_URL + 'SignIn', name: 'SignIn', component: SignIn, meta: { reuse: false } },
   // { path: process.env.BASE_URL + 'SignUp', name: 'SignUp', component: SignUp, meta: { reuse: false } },
   // { path: process.env.BASE_URL + 'CommonQuestions', name: 'CommonQuestions', component: CommonQuestions, meta: { reuse: false } },
   // { path: process.env.BASE_URL, name: 'Programs', component: HomePage, meta: { reuse: false } },
   // { path: process.env.BASE_URL, name: 'InterestedPartners', component: HomePage, meta: { reuse: false } },

   // { path: process.env.BASE_URL, name: 'Programs', component: HomePage, meta: { reuse: false } },
   // { path: process.env.BASE_URL, name: 'ProgramsTypePage', component: HomePage, meta: { reuse: false } },


    { path: process.env.BASE_URL, name: 'Home', component: HomePage, meta: { reuse: false } },
    { path: process.env.BASE_URL + 'SignIn', name: 'SignIn', component: SignIn, meta: { reuse: false } },
    { path: process.env.BASE_URL + 'SignUp', name: 'SignUp', component: SignUp, meta: { reuse: false } },
    { path: process.env.BASE_URL + 'CommonQuestions', name: 'CommonQuestions', component: CommonQuestions, meta: { reuse: false } },
    { path: process.env.BASE_URL + 'Programs/id=:id?', name: 'Programs', component: Programs, meta: { reuse: false } },
    { path: process.env.BASE_URL + 'InterestedPartners/typeId=:typeId?&id=:id?', name: 'InterestedPartners', component: InterestedPartners, meta: { reuse: false } },

    { path: process.env.BASE_URL + 'Programs/id=:id?', name: 'Programs', component: Programs, meta: { reuse: false } },
    { path: process.env.BASE_URL + 'ProgramsTypePage/typeId=:typeId?&id=:id?', name: 'ProgramsTypePage', component: ProgramsTypePage, meta: { reuse: false } },

]
const router = createRouter({
    history: createWebHistory(),
    mode: 'history',
    base: process.env.BASE_URL,
    routes

});
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.reuse === false)) {
        app.key = to.path
    } else {
        app.key = null
    }
    next()
})
export default router 